import { Baby, BadgeCheck } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';

export const ProductShowcase = () => {
    return (
        <section className="container mx-auto px-4 py-16">
            <div className="grid md:grid-cols-2 gap-16 items-center">
                <div className="px-6 py-4">
                    <Badge className="text-sm mb-6 bg-gradient-to-r from-violet-500/20 to-fuchsia-500/20 text-violet-600 dark:text-violet-400 hover:from-violet-500/30 hover:to-fuchsia-500/30 font-medium px-4 py-2">
                        Seamless Integration
                    </Badge>
                    <h2 className="text-3xl md:text-4xl font-bold mb-8 text-gray-800 dark:text-white">
                        The Smartest Diaper Sensor on the Market
                    </h2>
                    <p className="text-gray-600 dark:text-gray-300 text-lg mb-10">
                        Our patented sensor technology clips onto any diaper brand, transforming regular diapers into
                        smart monitoring devices that track wetness, temperature, and more.
                    </p>

                    <ul className="space-y-6 mb-10">
                        {[
                            "Real-time wetness notifications",
                            "Temperature monitoring for baby's comfort",
                            "Health analytics and hydration tracking",
                            "Works with any diaper brand",
                            "6-month battery life"
                        ].map((item, index) => (
                            <li key={index} className="flex items-start gap-4">
                                <BadgeCheck className="h-6 w-6 text-violet-600 dark:text-violet-400 shrink-0 mt-0.5" />
                                <span className="text-gray-700 dark:text-gray-300">{item}</span>
                            </li>
                        ))}
                    </ul>

                    <Button className="btn-baby bg-pink-600 text-white shadow-lg px-8 py-3 text-base">
                        Shop Now
                    </Button>
                </div>

                <div className="relative h-[500px] rounded-3xl overflow-hidden border-8 border-white dark:border-gray-800 shadow-2xl bg-gradient-to-br from-violet-500/5 via-fuchsia-500/5 to-blue-500/5 dark:from-violet-500/10 dark:via-fuchsia-500/10 dark:to-blue-500/10">
                    {/* Decorative gradient blobs */}
                    <div className="absolute -top-16 -left-16 w-32 h-32 rounded-full bg-pink-500/20 blur-2xl"></div>
                    <div className="absolute -bottom-8 -right-8 w-32 h-32 rounded-full bg-violet-500/20 blur-2xl"></div>

                    <div className="absolute inset-0 flex items-center justify-center">
                        <div className="w-48 h-48 rounded-full bg-gradient-to-br from-violet-500/30 to-fuchsia-500/30 flex items-center justify-center animate-pulse-slow">
                            <div className="w-36 h-36 rounded-full bg-gradient-to-r from-fuchsia-500/40 to-violet-500/40 flex items-center justify-center">
                                <div className="relative w-24 h-24 rounded-full bg-gradient-to-r from-violet-500/50 to-fuchsia-500/50 flex items-center justify-center">
                                    <Baby className="h-14 w-14 text-white" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="absolute bottom-8 left-0 right-0 flex justify-center">
                        <div className="bg-white dark:bg-gray-800 rounded-full px-6 py-3 shadow-xl flex items-center gap-3 border border-emerald-400/30">
                            <div className="w-3 h-3 rounded-full bg-emerald-500 animate-pulse"></div>
                            <span className="font-medium text-gray-800 dark:text-gray-200">Baby is dry and comfortable</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};